import cakeImage from "app/assets/images/about-us/cake-shape.png";
import { Marquee } from "~/modules/shared/components";

export function MadeByLove() {
  return (
    <Marquee autoFill className="bg-[#8E8E8E] py-4 text-white">
      <div className="flex items-center text-xl font-medium">
        <span className="px-4">
          <img src={cakeImage} alt="made-by-love" className="size-8" />
        </span>
        Made By Love
      </div>
    </Marquee>
  );
}
